import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";
import { VISIT_CYLINDER_CHANGE } from "../apiEndPoints";
import useGetHistory from "../../../CustomHooks/useAxios/useGetHistory";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import { setError } from "../../../redux/dataSlice";
import LoadingDisplay from "../../../components/UI/LoadingDisplay";
import { endDate, getDateBefore } from "../../../helpers/dateHelpers";
import { DateFilters } from "../../../components/Filter/dateFilters/DateFilters";
import { SiteCylinderChangeTable } from "../components/visitCylinderChnageReport/SiteCylinderChangeTable";
import { SummaryCards } from "../components/visitCylinderChnageReport/SummaryCards";

export const VisitCylinderChangeReportPage = () => {
  const [dateRange, setDateRange] = useState({
    start: "",
    end: "",
    currentSelector: "lastMonth",
  });
  const fromDate = getDateBefore(30);
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();
  const dispatch = useDispatch();
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);

  useEffect(() => {
    getHistory(`${VISIT_CYLINDER_CHANGE}/${fromDate}/${endDate}`);
  }, []);

  return (
    <MainPageLayout
      headerConfig={{ title: "Visit Cylinder Change Report" }}
      bgColor="bg-[#f0f2f7]"
    >
      <DateFilters
        dateRange={dateRange}
        setDateRange={setDateRange}
        getHistory={getHistory}
        baseUrl={VISIT_CYLINDER_CHANGE}
        loaded={historyLoaded}
      />
      {historyLoaded ? (
        <LoadingDisplay height="h-[80vh] mt-2" />
      ) : (
        isSucceed && (
          <>
            <SummaryCards />
            <SiteCylinderChangeTable />
          </>
        )
      )}
      {historyError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(historyErrMsg)}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
    </MainPageLayout>
  );
};
